import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"
import api from "../services/api"

export default function ProjectCardDetailed (props){

  const [p, setP] = useState('')
  const [u, setU] = useState('')
  const [projectId, setProjectId] = useState('')
  const [email, setEmail] = useState(props.userEmail)
  const [requests, setRequests] = useState([])
  
  useEffect(() => {
    // Find project data based on props.projectModal
    const projectData = props.projectData && props.projectData.find(item =>
      item.project_id === props.projectModal
    );
  
    // Find project user data based on props.projectModal
    const projectUserData = props.projectUserData && props.projectUserData.find(item =>
      item.project_id === props.projectModal
    );
  
    // Update state variables based on found data
    if (projectData) {
      setP(projectData);
      setProjectId(projectData.project_id);
      if (projectData.requests){
        setRequests(projectData.requests)
      } else {
        setRequests([])
      }
    } else {
      setP(''); // If data is not found, set state to null or handle accordingly
      setProjectId(''); // Set projectId to default value or handle accordingly
    }
  
    if (projectUserData) {
      setU(projectUserData);
    } else {
      setU(''); // If data is not found, set state to null or handle accordingly
    }
  
  }, []);
  
  

 

    // console.log(p.connections) 

  const requestConnect = async (e) => {
    e.preventDefault();
    // alert('connection requested ' + p.project_id)
    try {

      await api.put('/projectrequest', {
        projectId,
        email
      });
      // console.log('yup')
      // window.location = "/home";

    } catch (err) {
      console.error(err.message)
    }
  }



//DELETE card function
const deleteCard = async (e) => {
  e.preventDefault();
  // console.log(p.project_id)
  try {
    await api.delete(`/project`, {
      headers: {
        // Authorization: authorizationToken
      },
      data: {
        projectId: u.project_id
      }
    }).then(window.location = `/projects`)
    // add the line above so that project list automatically shows new shorter list when project is deleted
  } catch (err) {
      console.error(err.message)
  }
}


let imgStyle = {
  maxHeight: '80px',
  objectFit: 'contain',
  marginTop: '5px',
}

let h5Style = {
    fontSize: '18px',
    fontWeight: '700',
    textAlign: 'center',
    margin: '0'
  }

let pStyle = {
  fontSize: '16px',
  fontWeight: '500',
  textAlign: 'left',
  margin: '3px 0 0 0'
}

let labelStyle = {
  fontSize: '16px',
  fontWeight: '700',
  textAlign: 'left',
  width: '180px',
  margin: '3px 10px 0 0',
}

let rowStyle = {
  display: 'flex',
  margin: '3px 0 0 0',
}

let blueButtonStyle = {
  border: "1px solid #80a3db",
  background: '#80a3db',
  color: "#FFF",
  borderRadius: '5px',
  textAlign: 'center',
  padding: "10px",
  margin: '0 10px 0 10px',
  width: '100px',
  fontWeight: '600'
}

let blackButtonStyle = {
  border: '1px solid #292929',
  background: '#292929',
  color: "#FFF",
  borderRadius: '5px',
  textAlign: 'center',
  padding: "10px",
  margin: '0 10px 0 10px',
  width: '100px',
  fontWeight: '600'
}

let redButtonStyle = {
  border: "1px solid red",
  background: '#F25835',
  color: "#FFF",
  borderRadius: '5px',
  textAlign: 'center',
  padding: "10px",
  margin: '0 10px 0 10px',
  width: '100px',
  fontWeight: '600' 
}

// let iconSpecialty = `${specialty}`;
// let iconFormatted = iconSpecialty.toLowerCase().replace(/\s+/g, "");


return (
  <div style={{display: 'flex'}}>
    <div style={{width: '7vw'}}></div>
    <div style={{width: '86vw', display: 'flex', justifyContent: 'center', margin: '0 0 300px 0'}}>
      <div
        style={{
          width: '100%',
          maxWidth: '800px',
          margin: '40px 0 0 0'
        }}
      >
        {
          p
          ?
            <div
              key={p.projectId}
              style={{
                background: '#FFF',
                border: 'none',
                borderRadius: '10px',
                padding: '20px',
                margin: '20px 10px 10px 0',
              }}>
              <div style = {{display: 'flex', justifyContent: 'center'}}>
                <img
                  style = {imgStyle}
                  src={`/icons/${(p.specialty.toLowerCase().replace(/\s+/g, ""))}.png`}
                  alt={p.specialty}/>
              </div>
              <hr style = {{borderTop: '1px solid #8c8b8b'}}/>
              <h5 style = {h5Style}>
                {p.title}
              </h5>
              <hr style = {{borderTop: '1px solid #8c8b8b'}}/>
                  <div>
                      <div style={rowStyle}>
                        <p style = {labelStyle}>
                          Residency program:
                        </p>
                        <p style={pStyle}>
                          {p.institution}
                        </p>
                      </div>
                      <div style={rowStyle}>
                        <p style = {labelStyle}>
                          Specialty:
                        </p>
                        <p style={pStyle}>
                          {p.specialty}
                        </p>
                      </div>
                      <div style={rowStyle}>
                        <p style = {labelStyle}>
                          State:
                        </p>
                        <p style={pStyle}>
                          {p.state_name}
                        </p>
                      </div>
                      <div style={rowStyle}>
                        <p style = {labelStyle}>
                          Planned completion:
                        </p>
                        <p style={pStyle}>
                          {p.completion}
                        </p>
                      </div>
                      <div style={rowStyle}>
                        <p style = {labelStyle}>
                          Publication type:
                        </p>
                        <p style={pStyle}>
                          {p.publication_type}
                        </p>
                      </div>
                      <div style={rowStyle}>
                        <p style = {labelStyle}>
                          Study type:
                        </p>
                        <p style={pStyle}>
                          {p.study_type}
                        </p>
                      </div>
                      <div style={rowStyle}>
                        <p style = {labelStyle}>
                          Contact name:
                        </p>
                        <p style={pStyle}>
                          {p.formal_name}
                        </p>
                      </div>
                      <div style={rowStyle}>
                        <p style = {labelStyle}>
                          Skills needed:
                        </p>
                        <p style={pStyle}>
                          {p.skills}
                        </p>
                      </div>
                      <div style={{
                        display: 'flex',
                        margin: '24px 0 0 0',}}>
                        <p style = {labelStyle}>
                          Summary:
                        </p>
                      </div>
                      <div style={{rowStyle}}>
                        <p style={pStyle}>
                          {p.summary}
                        </p>
                      </div>
                  </div>
                  <div 
                    style={{
                      display: 'flex', 
                      justifyContent: "center",
                      margin: "40px 0 0 0",
                    }}
                  >
                    {
                    u
                    ? 
                    <>
                      <Link
                        onClick={()=>props.setProjectModal(p.project_id)}
                        to={"/projectedit"}
                        style={{textDecoration: 'none'}}
                      >
                        <div
                          style={blueButtonStyle}
                        >
                          Edit
                        </div>
                      </Link>  
                      <Link
                        onClick={()=>props.setProjectModal('')}
                        to={"/project"}
                        style={{textDecoration: 'none'}}
                      >
                        <div
                          style={blackButtonStyle}
                        >
                          Cancel
                        </div>
                      </Link>
                      <div
                        style={redButtonStyle}
                        onClick={e => deleteCard(e)}
                      >
                        Delete
                      </div>
                    </>
                    : props.userType === 'prephysician'  && requests.find(m => 
                      m !== email)
                      ?
                      <>
                        <div
                          onClick={(e) => requestConnect(e)}
                          style={blueButtonStyle}
                        >
                          Connect
                        </div>
                        <Link
                          onClick={()=>props.setProjectModal('')}
                          to={"/projects"}
                          style={{textDecoration: 'none'}}
                        >
                          <div
                            style={blackButtonStyle}
                          >
                            Go back
                          </div>
                        </Link>
                      </>
                    : (props.userType === 'prephysician')  && (requests && requests.find(m => m === email))
                      ?
                      <>
                        <div
                          onClick={(e) => requestConnect(e)}
                          style={blueButtonStyle}
                        >
                          Request sent
                        </div>
                        <Link
                          onClick={()=>props.setProjectModal('')}
                          to={"/projects"}
                          style={{textDecoration: 'none'}}
                        >
                          <div
                            style={blackButtonStyle}
                          >
                            Go back
                          </div>
                        </Link>
                      </>
                      
                     : props.userType === ''
                    ?  
                    <>
                      <Link
                        to={'/login'}
                        style={{textDecoration: 'none'}}
                      >
                        <div      
                          style={blueButtonStyle}
                        >
                          Connect
                        </div>
                      </Link>
                      <Link
                        onClick={()=>props.setProjectModal('')}
                        to={"/projects"}
                        style={{textDecoration: 'none'}}
                      >
                        <div
                          style={blackButtonStyle}
                        >
                          Go back
                        </div>
                      </Link>
                    </>
                    : null
                  }
              </div>
              </div>
                        
        : null
      }
      </div>
      </div>
    <div style={{width: '7vw'}}></div>
  </div>      
  )
}

